import { logEvent } from 'commons/utils/tracking';
import { CATEGORIES_SAVE_METAFIELDS } from 'config/trackingEvents';

export const trackingCategoriesSaveMetafield = (categoryId: string): void => {
  logEvent(CATEGORIES_SAVE_METAFIELDS, {
    category_id: categoryId,
  });
};
